import CrossCircleIconPath from "@ingka/ssr-icon/paths/cross-circle";

export default CrossCircleIconPath;
